import { BFF_API_ROUTES } from 'constants/apiRoutes';

import { baseRTKApi } from 'shared/api/baseApi';
import type { TRankingProductClientResponse, TRankingProductRequest } from 'shared/types/TRankingService';

export const queries = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    getSelectionProduct: build.query<TRankingProductClientResponse, TRankingProductRequest>({
      query: (query) => ({
        url: BFF_API_ROUTES.getSelectionProduct,
        body: query,
        method: 'POST',
      }),
    }),
  }),
});

export const { useLazyGetSelectionProductQuery } = queries;
